import React, { useContext, useEffect, useState } from 'react';
import Breadcrumb from '../../Breadcrumb/Breadcrumb';
import axios from '../../../axios';
import { BlobProvider } from '@react-pdf/renderer';
import ReporteGlobalPDF from '../PDFs/ReporteGlobalPDF';
import { UserContext } from '../../../UserContext';
import { checkPermiso } from '../../../Utils/PermissionsFunctions';
import Loader from '../../../Layout/Loaders/Loader';
const today = new Date(new Date(new Date().setHours(0, 0, 0, 0)).toString().split('GMT')[0] + ' UTC').toISOString();
const todayEnd = new Date(new Date(new Date().setHours(23, 59, 59, 999)).toString().split('GMT')[0] + ' UTC').toISOString();

const ReporteGlobal = () => {
    const {user} = useContext(UserContext);
    const [dia,setDia] = useState(new Date());
    const [rango,setRango] = useState({field:'fecha_pedido',start:today,end:todayEnd});
    const [totales,setTotales] = useState({globalPedidos:0,globalTotal:0});
    const [ordenes,setOrdenes] = useState([]);
    const [sucursales,setSucursales] = useState([]);
    const [loader,setLoader] = useState([]);
    const [permisos,setPermisos] = useState({
        orders_read:null,
    });
    
    const handleDate = (e) => {
        let date =  new Date(e.target.value);
        date.setDate(date.getDate());
        let nextDate = new Date(e.target.value);
        nextDate.setDate(date.getDate()+1);
        //date.toLocaleString('en-US', { timeZone: 'America/Mexico_City' });
        setDia(nextDate);
        setRango({...rango,start:date,end:nextDate});
    }

     useEffect(()=>{
            _getSucursales();
            if(user.id){
                console.log("USer",user);
                setPermisos((prevPremisos) => ({
                    ...prevPremisos,
                    orders_read:checkPermiso("orders_read",user.permissions)
                })); 
                setRango({...rango,sucursal_id:user.sucursal_id});
            }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        },[user]);
    

     useEffect(()=>{
        setLoader(true);
        if(permisos.orders_read) getPedidos();
    },[permisos,rango]);

    const getPedidos = () =>{
        axios.post("/api/global-incomes-report",rango).then((resp)=>{
            console.log("Ordernes",resp);
            setOrdenes(resp.data)
            calcularTotales(resp.data);
            setLoader(false);
        }).catch(e=>console.log("Error",e))
    }

    const calcularTotales = (pedidos) =>{
        if(pedidos.length > 0){
            let totalGlobal = 0;
            let pedidosGlobal = 0;
            for (let index = 0; index < pedidos.length; index++) {
                totalGlobal += pedidos[index].data.total;
                pedidosGlobal += pedidos[index].data.pedidosTotal;
            }
            setTotales({...totales,globalPedidos:pedidosGlobal,globalTotal:totalGlobal});
        }
    }

    const _getSucursales = () =>{
        axios.get('api/sucursals').then((resp)=>{
            setSucursales(resp.data)
        }).catch(e=>console.error("Error ",e));
    }

    const renderSucursalName = () =>{
        let sucursal = sucursales.find(suc=>suc.id == rango.sucursal_id);
        return sucursal ? sucursal.nombre_sucursal : "";
    }

    return (
        <div>
             <div className='container-admin-menu '> <Breadcrumb hasButton={true} hasFilters={false} /> </div>
             <div className='container-admin-container'>
                <div className='container-admin z-depth-1 row'>
                    <div className='row col s12 info-badge border-r-10 m-p-0 centrar-h' style={{bordeRadius:'10px!important', padding:'0px!important',}}>
                        <div className="col s12 m6 p-0">
                           <h5>Reporte Global de Ingresos - {renderSucursalName()}</h5>
                           <div>Fecha Analisis: {dia.toLocaleDateString("es-MX", { year: 'numeric', month: 'long', day: 'numeric' })} </div>
                        </div>
                        <div className="row col s12 m6 input-text">
                            <div className='col s12 m4 m-p-0 centrar'>
                            {!loader &&
                                <BlobProvider document={<ReporteGlobalPDF ordenes={ordenes} totales={totales}/>}>
                                {({url}) => (
                                    <a className="btn-blanco puntero" style={{marginTop:15}} href={url} target="_blank" rel="noreferrer">
                                        <img className='col s2 m2 m-p-0 dentometric centrar' src='/images/pdf-reporte.png' alt='reporte PDF' style={{width:'20px'}} />
                                        <span className='centrar'> &nbsp;&nbsp;Descargar PDF </span>
                                    </a>
                                )}
                                </BlobProvider>
                            }
                            </div>
                            <div className='col s12 m4'>
                                <label htmlFor="dia">Selecciona una sucursal</label>
                                <select className='browser-default' style={{maxHeight:30}} onChange={(e)=>setRango({...rango,sucursal_id:e.target.value})} value={rango.sucursal_id}>
                                    <option value="" disabled selected>Selecciona una sucursal</option>
                                    {sucursales.map((suc) =>
                                        <option value={suc.id}  key={suc.id}>{suc.nombre_sucursal}</option>
                                    )}
                                </select>

                            </div>
                            <div className='col s12 m4'>
                                <label htmlFor="dia">Seleccionar día</label>
                                <input id="dia" type="date" onChange={handleDate}/>
                            </div>
                       
                        </div>
                    </div>
                    {!loader ? 
                     ordenes.map((orden,index)=>
                        <>
                            <div className='col s12 row m-t-10 z-depth-1 p-10 border-r-6 centrar' key={index}>
                                <div className="container p-10 table table-doc">
                                    <div className='row m-p-0 table-header'>
                                        <div className='col s12 m2' style={{border:'solid 1px'}}>
                                            {orden.empleado_id}
                                        </div>
                                        <div className='col s12 m10' style={{border:'solid 1px'}}>
                                            {orden.empleado}
                                        </div>
                                    </div>
                                    <>
                                        <div className='row m-p-0' style={{display:'flex'}}>
                                            <div className='col s12 m2' style={{border:'solid 1px'}}></div>
                                            <div className='col s12 m4 negritas' style={{border:'solid 1px'}}>
                                                PEDIDOS:
                                            </div>
                                            <div className='col s12 m6 negritas' style={{border:'solid 1px'}}>
                                                SUBTOTAL:
                                            </div>
                                        </div>
                                        <div className='row m-p-0'>
                                            <div className='col s12 m2' style={{border:'solid 1px'}}>
                                                EFECTIVO
                                            </div>
                                            <div className='col s12 m4' style={{border:'solid 1px'}}>
                                                {orden.data.efectivo.pedidos.toFixed(2)}
                                            </div>
                                            <div className='col s12 m6' style={{border:'solid 1px'}}>
                                                ${orden.data.efectivo.subTotal.toFixed(2)}
                                            </div>
                                        </div>
                                        <div className='row m-p-0'>
                                            <div className='col s12 m2' style={{border:'solid 1px'}}>
                                                TARJETAS
                                            </div>
                                            <div className='col s12 m4' style={{border:'solid 1px'}}>
                                                {orden.data.credito.pedidos.toFixed(2)}
                                            </div>
                                            <div className='col s12 m6' style={{border:'solid 1px'}}>
                                                ${orden.data.credito.subTotal.toFixed(2)}
                                            </div>
                                        </div>
                                        <div className='row m-p-0'>
                                            <div className='col s12 m2' style={{border:'solid 1px'}}>
                                                DEBITO
                                            </div>
                                            <div className='col s12 m4' style={{border:'solid 1px'}}>
                                                {orden.data.debito.pedidos.toFixed(2)}
                                            </div>
                                            <div className='col s12 m6' style={{border:'solid 1px'}}>
                                                ${orden.data.debito.subTotal.toFixed(2)}
                                            </div>
                                        </div>
                                        <div className='row m-p-0'>
                                            <div className='col s12 m2' style={{border:'solid 1px'}}>
                                                TRANSF:
                                            </div>
                                            <div className='col s12 m4' style={{border:'solid 1px'}}>
                                                {orden.data.transferencia.pedidos.toFixed(2)}
                                            </div>
                                            <div className='col s12 m6' style={{border:'solid 1px'}}>
                                                ${orden.data.transferencia.subTotal.toFixed(2)}
                                            </div>
                                        </div>
                                        <div className='row m-p-0 m-t-10'>
                                            <div className='col s12 m2' style={{border:'solid 1px'}}>
                                                GASTOS:
                                            </div>
                                            <div className='col s12 m4' style={{border:'solid 1px'}}>
                                                {orden.data.gastos.pedidos.toFixed(2)}
                                            </div>
                                            <div className='col s12 m6' style={{border:'solid 1px'}}>
                                                ${orden.data.gastos.subTotal.toFixed(2)}
                                            </div>
                                        </div>
                                        <div className='row m-p-0 m-t-10'>
                                            <div className='col s12 m6' style={{border:'solid 1px'}}>
                                                TOTAL DE EFECTIVO:
                                            </div>
                                            <div className='col s12 m6' style={{border:'solid 1px'}}>
                                                ${orden.data.totalEfectivo.toFixed(2)}
                                            </div>
                                        </div>
                                    </>
                                

                                    <div className='m-p-0 m-t-25 table-container'>
                                        <div className='row'>
                                            <div className='col s12 m2' style={{border:'solid 1px'}}>
                                                TOTAL:
                                            </div>
                                            <div className='col s12 m4' style={{border:'solid 1px'}}>
                                                {orden.data.pedidosTotal.toFixed(2)}
                                            </div>
                                            <div className='col s12 m6' style={{border:'solid 1px'}}>
                                                ${orden.data.total.toFixed(2)}
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                            <div className='col s12 row m-t-10 z-depth-1 p-10 border-r-6 centrar '>
                                <div className='container p-10'>
                                    <div className='row m-p-0' style={{display:'flex'}}>
                                        <div className='col s12 m2' style={{border:'solid 1px'}}></div>
                                        <div className='col s12 m4 negritas' style={{border:'solid 1px'}}>
                                            PEDIDOS:
                                        </div>
                                        <div className='col s12 m6 negritas' style={{border:'solid 1px'}}>
                                            TOTAL:
                                        </div>
                                    </div>

                                    <div className='row m-p-0 negritas' style={{display:'flex'}}>
                                        <div className='col s12 m3' style={{border:'solid 1px'}}> Global:</div>
                                        <div className='col s12 m3 ' style={{border:'solid 1px'}}>
                                        {totales.globalPedidos.toFixed(2)}
                                        </div>
                                        <div className='col s12 m6 negritas' style={{border:'solid 1px'}}>
                                            ${totales.globalTotal.toFixed(2)}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </>
                    )
                    :
                    <Loader></Loader>
                    }
                </div> 
            </div> 
        </div>
    );
};

export default ReporteGlobal;